module.exports = __webpack_public_path__ + "static/battery_icon-1d975762210f87e2eeae9c153c269987.png";